import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { reactLocalStorage as ls } from 'reactjs-localstorage'

export enum Theme {
    Dark = 'dark-mode',
    Light = 'light-mode',
}

interface State {
    theme: Theme
}

const initialState: State = {
    theme: Theme.Light
}

const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        setTheme: (state, action: PayloadAction<Theme>) => {
            state.theme = action.payload
            ls.set('theme', action.payload)
            toggleClass(action.payload)
        },
        toggleTheme: (state) => {
            state.theme = state.theme === Theme.Dark ? Theme.Light : Theme.Dark
            toggleClass(state.theme)
            ls.set('theme', state.theme)
        },
    }
})

const toggleClass = (theme: string) => {
    document.body.removeAttribute('class')
    document.body.classList.add(theme)
}

export const { toggleTheme, setTheme } = themeSlice.actions
export default themeSlice.reducer